import React from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import {
  showHelperInfoAtom
} from '../../../atoms/Atoms';
import Configurations from './shared-components/Configurations';

function ManagerVersionConfiguration() {
  const { t } = useTranslation();
  const setShowHelperInfo = useSetRecoilState(showHelperInfoAtom);
  return (
    <>
      <Button
        className="float-right mt-4 mr-6"
        type="primary"
        onClick={() => setShowHelperInfo('managerconfig')}
      >
        <InfoCircleFilled /> {t('help')}
      </Button>
      <br />
      <br />
      <Configurations
        title={t('manager_verison_config')}
        containerName="configs"
        fileName="manager-version.json"
      />
    </>
  );
}

export default ManagerVersionConfiguration;
